import React from 'react'
import { Handle } from 'rc-slider';
import Tooltip from 'rc-tooltip';

export default function ToolTipHandle(props) {
  // console.log('props', props);
  const {
    value,
    dragging,
    overlay,
    index,
    visible,
    ...restProps
  } = props;

  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging || visible}
      placement="top"
      key={index}
    >
      <Handle
        value={value}
        {...restProps}
      />
    </Tooltip>
  );

}



// WEBPACK FOOTER //
// ./src/components/ToolTipHandle.jsx